export const pass = /^(?=.*\d).{8,}$/;
export const passOptimo = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/;
export const mail = /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/;
export const tlfn = /^[+]?\d+(\.\d+)?$/;